export const sensorPlaceTypeConstants = {
    GET_ALL_REQUEST: 'SENSOR_PLACE_TYPES_GET_ALL_REQUEST',
    GET_ALL_SUCCESS: 'SENSOR_PLACE_TYPES_GET_ALL_SUCCESS',
    GET_ALL_FAILURE: 'SENSOR_PLACE_TYPES_GET_ALL_FAILURE',

    GET_ONE_REQUEST: 'SENSOR_PLACE_TYPES_GET_ONE_REQUEST',
    GET_ONE_SUCCESS: 'SENSOR_PLACE_TYPES_GET_ONE_SUCCESS',
    GET_ONE_ERROR: 'SENSOR_PLACE_TYPES_GET_ONE_ERROR',

    DELETE_REQUEST: 'SENSOR_PLACE_TYPES_DELETE_REQUEST',
    DELETE_SUCCESS: 'SENSOR_PLACE_TYPES_DELETE_SUCCESS',
    DELETE_FAILURE: 'SENSOR_PLACE_TYPES_DELETE_FAILURE',

    CREATE_REQUEST: 'SENSOR_PLACE_TYPES_CREATE_REQUEST',
    CREATE_SUCCESS: 'SENSOR_PLACE_TYPES_CREATE_SUCCESS',
    CREATE_FAILURE: 'SENSOR_PLACE_TYPES_CREATE_FAILURE',

    UPDATE_REQUEST: 'SENSOR_PLACE_TYPES_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'SENSOR_PLACE_TYPES_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'SENSOR_PLACE_TYPES_UPDATE_FAILURE',

    OPEN_VIEW_DRAWER_REQUEST: 'SENSOR_PLACE_TYPES_OPEN_VIEW_DRAWER_REQUEST',
    OPEN_VIEW_DRAWER_SUCCESS: 'SENSOR_PLACE_TYPES_OPEN_VIEW_DRAWER_SUCCESS',
    OPEN_VIEW_DRAWER_FAILURE: 'SENSOR_PLACE_TYPES_OPEN_VIEW_DRAWER_FAILURE',

    CLOSE_VIEW_DRAWER: 'SENSOR_PLACE_TYPES_CLOSE_VIEW_DRAWER_REQUEST',

    OPEN_CREATE_MODAL: 'SENSOR_PLACE_TYPES_OPEN_CREATE_MODAL',
    CLOSE_CREATE_MODAL: 'SENSOR_PLACE_TYPES_CLOSE_CREATE_MODAL',

    OPEN_DELETE_MODAL_REQUEST: 'SENSOR_PLACE_TYPES_OPEN_DELETE_MODAL_REQUEST',
    OPEN_DELETE_MODAL_SUCCESS: 'SENSOR_PLACE_TYPES_OPEN_DELETE_MODAL_SUCCESS',
    OPEN_DELETE_MODAL_FAILURE: 'SENSOR_PLACE_TYPES_OPEN_DELETE_MODAL_FAILURE',

    CLOSE_DELETE_MODAL: 'SENSOR_PLACE_TYPES_CLOSE_DELETE_MODAL',
};
